import { ErrorModel } from '@spartacus/core';
import { Column } from '../../../SGRE-shared/models/tableConfiguration';
import { UsersTableData } from '../model/user-page-model'

export const USER_DATA_FEATURE = 'User-Table';

export interface StateWithUserData {
  [USER_DATA_FEATURE]: UserState;
}
export interface UserState {
  b2bCustomers: UserStateInitial,
  loading?: boolean;
  error?: ErrorModel;
  success?: boolean
}
export interface UserStateInitial {
  columns: Column[],
  userstableData: UsersTableData[]
}

export interface updateTableState {
  updated: boolean;
}
